import React from 'react';
import './Loader.css';
import logo from '../../assets/img/Logo_Branco_Estado_MT.png';
import { useSelector } from 'react-redux';

export default function Loader(props) {
    const count = useSelector((state) => state.counterRequestReducer.counterRequest);
    const isLoading = count > 0;

    function Loader() {
        return (
            <div className="loader-overlay">
                <img className="text" src={logo} style={{ width: '13%' }} alt="loader" />
                <div className="lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <span className="msg">{props.text ? props.text : 'Carregando'}</span>
            </div>
        );
    }
    return <>{isLoading ? <Loader /> : false}</>;
}
